module.exports = __webpack_public_path__ + "img/gnjs.c177f000.png";